module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_pc_001-4486b45757697e1bb09d284254377fbc.png";